import { render, staticRenderFns } from "./dategroup.vue?vue&type=template&id=0d8206c4&scoped=true&"
import script from "./dategroup.vue?vue&type=script&lang=js&"
export * from "./dategroup.vue?vue&type=script&lang=js&"
import style0 from "./dategroup.vue?vue&type=style&index=0&id=0d8206c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8206c4",
  null
  
)

export default component.exports